import { render, staticRenderFns } from "./WidgetDetails.vue?vue&type=template&id=0b8e3d72&"
import script from "./WidgetDetails.vue?vue&type=script&lang=ts&"
export * from "./WidgetDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports